<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table-list"></i>
        WFDetector(Web Forgery Detectior) Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WFDetector</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Dashboard</a>
        </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> WFDetect(Web Forgery Detection) Dashboard
      </template> -->
        <b-row>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h1><strong>
                  <number ref="module_check_1" :from="0" :to="info.from && info.from.alive ? info.from.alive : 0" :format="value_comma" :duration="2"/>
                  <sup style="font-size: 20px"> Usage</sup></strong></h1>
                <hr>
                <h6>Recent information</h6>
                <h4>Active :
                  <number ref="module_check_1" :from="0" :to="info.from && info.from.alive ? info.from.alive : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>inactive :
                  <number ref="module_check_2" :from="0" :to="info.from && info.from ? info.from.total - info.from.alive : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>Total :
                  <number ref="module_check_2" :from="0" :to="info.from && info.from.total ? info.from.total : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-success">
              <b-card-body class="pb-0" >
                <h1><strong>
                  <number ref="server_check_1" :from="0" :to="info && info.server && info.server.alive > 0 ? info.server.alive : 0" :format="value_comma" :duration="2"/>
                  <sup style="font-size: 20px"> Server</sup></strong></h1>
                <hr>
                <h6>Recent information</h6>
                <h4>Enabled :
                  <number ref="server_check_2" :from="0" :to="info && info.server.alive && info.server.alive > 0 ? info.server.alive : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>Disabled :
                  <number ref="server_check_3" :from="0" :to="info && info.server.deleted && info.server.deleted > 0 ? info.server.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>Total :
                  <number ref="server_check_4" :from="0" :to="info && info.server.alive && info.server ? info.server.alive + info.server.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-info">
              <b-card-body class="pb-0">
                <h1><strong>
                  <number ref="domain_check_1" :from="0" :to="info && info.domain && info.domain.alive > 0 ? info.domain.alive : 0" :format="value_comma" :duration="2"/>
                <sup style="font-size: 20px"> Domain</sup></strong></h1>
                <hr>
                <h6>Recent information</h6>
                <h4>Enabled :
                  <number ref="domain_check_2" :from="0" :to="info && info.domain && info.domain.alive > 0 ? info.domain.alive : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>Disabled :
                  <number ref="domain_check_3" :from="0" :to="info && info.domain && info.domain.deleted > 0 ? info.domain.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>Total :
                  <number ref="domain_check_4" :from="0" :to="info && info.domain && info.domain.alive > 0 ? info.domain.alive + info.domain.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h1><strong>
                    <number ref="detect_check_1" :from="0" :to="info && info.detect && info.detect.day > 0 ? info.detect.day : 0" :format="value_comma" :duration="2"/>
                <sup style="font-size: 20px"> Detect</sup></strong></h1>
                <hr>
                <h6>Recent information</h6>
                <h4>Today :
                  <number ref="detect_check_2" :from="0" :to="info && info.detect && info.detect.day > 0 ? info.detect.day : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>Last 7 days :
                  <number ref="detect_check_3" :from="0" :to="info && info.detect && info.detect.week > 0 ? info.detect.week : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>This Month :
                  <number ref="detect_check_4" :from="0" :to="info && info.detect && info.detect.month > 0 ? info.detect.month : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card ref="_ms" v-else>
      <b-row>
        <b-col class="title">
          Agent Status (Max 100)
          <b-button class="float-right ml-2" size="m" variant='success' to="/downloads">New Server</b-button>
          <b-button class="float-right ml-2" size="m" variant='success' to="/wmds/site">New Domain</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center">
        <agent-item v-for="(item, index) in agents" :key="index" :ref="`_agent_${index}`" :agent="item"></agent-item>
      </b-row>
      <b-row v-if="this.count == 0" style="text-align:center;">
        <b-col sm="6" lg="12">
          <b-card no-body class="bg-success">
            <b-card-body class="pb-20">
              <h3 class="mb-0">No Agent Installed</h3>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <router-view ></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
